import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Router } from "@angular/router";
import { Announcement } from '../../models/announcement/announcement.model';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { CookieService } from 'ngx-cookie-service';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class AnnouncementService {
  private service = "api/Announcement"; //Controller Name
  public AnnouncementList: Announcement[];
  constructor(private http: Http, private readonly router: Router, private cookieService: CookieService) { }

  AddAnnouncement(announcement: Announcement): void {


    const httpOptions = {
      headers: new HttpHeaders({
        "Token": this.cookieService.get('Login')
      })
    };

    this.http
      .post(`${this.service}`, announcement, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })})
      .subscribe(result => {
        this.router.navigate(["/announcement-list"]);
      });
  }
  UpdateAnnouncement(announcement: Announcement): void {
    this.http
      .put(`${this.service}`, announcement, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .subscribe(result => {
        this.router.navigate(["/announcement-list"]);
      });
  }

  GetAnnouncements() {
    return this.http.get(`${this.service}`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetAnnouncementById(id: string) {
    return this.http.get(`${this.service}/` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => <Announcement>response.json())
      .catch(this.errorHandler)
  }
  DeleteAnnouncement(id: string) {
    return this.http.delete(`${this.service}/` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .subscribe(result => {
      });
  }
  errorHandler(error: Response) {
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/announcement/announcement.service.ts